const FIAT_COINS = ['USD', 'EUR', 'GBP']

export const findTier = (prices, ticker, liquidityTiers) => {
  if (!ticker) return null

  if (FIAT_COINS.includes(ticker)) return 1

  const value = Number(prices[ticker]?.highestVolume || 0)
  const tier = liquidityTiers.find((tier) => value >= tier.marketVolume)
  return tier.tier ? tier.tier : liquidityTiers.length
}
